export function useFileOperations() {
  const downloadFiles = (projectId: string | undefined) => {
    if (!projectId) {
      console.error("No project ID available");
      return;
    }
    const downloadUrl = `/api/projects/${projectId}/files/download`;
    window.location.href = downloadUrl;
  };

  return {
    downloadFiles,
  };
}
